import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { LicenseMgtActionTypes, LicenseMgtActions } from '../actions/license-mgt.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import * as featureActions from '../../index';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import { LicenseMgtListActionTypes } from '../../index';

@Injectable()
export class LicenseMgtEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  ReadLicenseMgts$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtActionTypes.GetLicenseMgts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.licenseMgtService.ReadLicenseMgt(user.otp).pipe(
        map((res: any) => {
          if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
            return new featureActions.LoadLicenseMgts(res.msg.body);
          } else {
            return new featureActions.LoadLicenseMgts([]);
          }
        })
      );
    })
  ));
  AddLicenseMgt$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtActionTypes.AddLicenseMgts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.AddLicenseMgt(payload).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.AddLicenseMgt };
          if (result.result) {
            return [new featureActions.GetLicenseMgts(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddLicenseMgt
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  UpdateLicenseMgt$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtActionTypes.UpdateLicenseMgts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp: user.otp,
        regionId: action.payload.regionId,
        mgtId: action.payload.mgtId,
        licenseQty: action.payload.licenseQty
      };
      return this.licenseMgtService.UpdateLicenseMgt(param).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.EditLicenseMgt };
          if (result.result) {
            const licenseMgtParam = { syncAccountsInfo: true};
            return [new featureActions.GetLicenseMgts(),
              new featureActions.GetLicenseMgtLists(licenseMgtParam),
              new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            const failResult = { ...result, result: false };
            return [new featureActions.UpdateInfoFailAction(failResult)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditLicenseMgt
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  DeleteLicenseMgt$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtActionTypes.GetDeleteLicenseMgts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        id: action.payload.id
      };
      return this.licenseMgtService.DeleteLicenseMgt(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteLicenseMgt };
          if (result.result) {
            const licenseMgtParam = { syncAccountsInfo: true};
            return [new featureActions.DeleteLicenseMgts({id: params.id}), new featureActions.GetLicenseMgtLists(licenseMgtParam)
              , new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }}
        ),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteLicenseMgt
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
    );
    })
  ));
  ConfirmLicenseMgt$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtActionTypes.ConfirmLicenseMgts),
    map((action: featureActions.ConfirmLicenseMgts) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const requestPayload = { ...payload, otp: user.otp };
      return this.licenseMgtService.ConfirmLicense(requestPayload).pipe(
        switchMap(res => {
          const result = { ...res, type: updateInfoType.ConfirmLicenseMgt };
          if (result.result) {
            return [new featureActions.GetLicenseMgts(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ConfirmLicenseMgt
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

}
